import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { translate } from 'react-translate';
import { Dropdown, Form, Label, Table } from 'semantic-ui-react';
import envList from '../../constants/envList';
import ProductType from '../../constants/ProductType';
import API from '../../services/Api';
import RtMaxService from '../../services/rtMaxService';
import UserService from '../../services/userService';
import { TechnicalInfoIcon } from './TechnicalInfoIcon';

class ComponentTableIME extends Component {
  static clickDownloadPdf(urlToOpen) {
    if (urlToOpen) {
      const windowRef = window.open(urlToOpen, '_blank');
      windowRef.focus();
    }
  }

  static propTypes = {
    isoValue: PropTypes.number,
    onConformitychange: PropTypes.func,
    onIsEnoughChange: PropTypes.func,
    onThermalChange: PropTypes.func,
    onTotalChange: PropTypes.func,
    resValue: PropTypes.number,
    t: PropTypes.func,
    worktype: PropTypes.string,
  }

  constructor(props) {
    super(props);
    this.state = {
      size: window.innerWidth,
    };

    this.changeInsulator = this.changeInsulator.bind(this);
    this.changeSupport = this.changeSupport.bind(this);
    this.changeMembrane = this.changeMembrane.bind(this);
    this.onClickTechnicalInfo = this.onClickTechnicalInfo.bind(this);
  }

  componentDidMount() {
    const { resValue, isoValue, worktype } = this.props;

    Promise.all([
      API.getPreselect(resValue, true, 0),
      API.getProducts(),
    ]).then(([{ data: { preselect } }, res]) => {
      const products = RtMaxService.getProducts(
        res,
        preselect,
        isoValue,
        envList.IME.path,
        worktype
      );

      const costData = [
        {
          type: ProductType.INSULATOR,
          productData: products.selectedInsulator,
        },
        {
          type: ProductType.SUPPORT,
          productData: products.selectedSupport,
        },
        {
          type: ProductType.PASTILLE,
          productData: products.selectedPastille,
        },
        {
          type: ProductType.ADHESIVE,
          productData: products.selectedAdhesif,
        },
        {
          type: ProductType.MASTIC,
          productData: products.selectedMastic,
        },
      ];

      if (worktype === '2') {
        costData.push(
          {
            type: ProductType.MEMBRANE,
            productData: products.selectedMembrane,
          }
        );
      }

      const costs = RtMaxService.calculateCost(costData, isoValue, envList.IME.path);

      const {
        insulator,
        support,
        membrane,
        pastille,
        adhesive,
        mastic,
      } = costs;
      this.setState(
        {
          ...products,
          ...membrane,
          ...pastille,
          ...adhesive,
          ...mastic,
          usedInsulator: insulator.usedInsulator,
          insulatorRoll: insulator.nbRoll,
          insulatorCost: insulator.insulatorCost,
          usedSupport: support.usedSupport,
          supportBox: support.nbBox,
          supportCost: support.supportCost,
        },
        () => {
          this.calculateThermalvalue();
          this.calculTotal();
        }
      );
    });
    window.addEventListener('resize', this.resize.bind(this));
  }

  onClickTechnicalInfo() {
    const { selectedInsulator } = this.state;
    if (selectedInsulator) ComponentTableIME.clickDownloadPdf(selectedInsulator.link);
  }

  resize = () => {
    this.setState({ size: window.innerWidth });
  }

  getJob = () => {
    const token = sessionStorage.getItem('USER_TOKEN');
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace('-', '+').replace('_', '/');
    const tmp = JSON.parse(window.atob(base64));
    return tmp.job;
  };

  changeSupport = (_, val, noFormat) => {
    const { supports, selectedSupport } = this.state;

    for (let i = 0; i < supports.length; i++) {
      if (supports[i].text === selectedSupport.name) {
        supports[i].value.price = val.value;
        supports[i].value.noFormat = noFormat;
      }
    }

    this.setState({
      supports,
      selectedSupport: {
        ...selectedSupport,
        price: val.value,
        noFormat,
      },
    }, () => {
      this.calculateSupport();
    });
  }

  changeMembranePrice = (_, val, noFormat) => {
    const { membranes, selectedMembrane } = this.state;

    for (let i = 0; i < membranes.length; i++) {
      if (membranes[i].text === selectedMembrane.name) {
        membranes[i].value.price = val.value;
        membranes[i].value.noFormat = noFormat;
      }
    }
    this.setState({
      membranes,
      selectedMembrane: {
        ...selectedMembrane,
        price: val.value,
        noFormat,
      },
    }, () => {
      this.calculateMembrane();
    });
  }

  changePastillePrice = (_, val, noFormat) => {
    const { pastilles, selectedPastille } = this.state;

    for (let i = 0; i < pastilles.length; i++) {
      if (pastilles[i].text === selectedPastille.name) {
        pastilles[i].value.price = val.value;
        pastilles[i].value.noFormat = noFormat;
      }
    }

    this.setState({
      pastilles,
      selectedPastille: {
        ...selectedPastille,
        price: val.value,
        noFormat,
      },
    }, () => {
      this.calculatePastille();
    });
  }

  changeAdhesifPrice = (_, val, noFormat) => {
    const { adhesifs, selectedAdhesif } = this.state;

    for (let i = 0; i < adhesifs.length; i++) {
      if (adhesifs[i].text === selectedAdhesif.name) {
        adhesifs[i].value.price = val.value;
        adhesifs[i].value.noFormat = noFormat;
      }
    }
    this.setState({
      selectedAdhesif: {
        ...selectedAdhesif,
        noFormat,
        price: val.value,
      },
      adhesifs,
    }, () => {
      this.calculateAdhesif();
    });
  }

  changeMasticPrice = (_, val, noFormat) => {
    const { mastics, selectedMastic } = this.state;

    for (let i = 0; i < mastics.length; i++) {
      if (mastics[i].text === selectedMastic.name) {
        mastics[i].value.price = val.value;
        mastics[i].value.noFormat = noFormat;
      }
    }

    this.setState({
      selectedMastic: {
        ...selectedMastic,
        price: val.value,
        noFormat,
      },
      mastics,
    }, () => {
      this.calculateMastic();
    });
  }

  changeMembrane= (_, val) => {
    const { isoValue } = this.props;

    const costs = RtMaxService.calculateCost([
      {
        type: ProductType.MEMBRANE,
        productData: val.value,
      },
    ], isoValue, envList.IME.path);
    const { membrane } = costs;

    this.setState({
      selectedMembrane: val.value,
      ...membrane,
    });
  }

  changeInsulator(_, val, noFormat) {
    const { insulators, selectedInsulator } = this.state;

    for (let i = 0; i < insulators.length; i++) {
      if (insulators[i].text === selectedInsulator.name) {
        insulators[i].value.price = val.value;
        insulators[i].value.noFormat = noFormat;
      }
    }

    this.setState({
      selectedInsulator: {
        ...selectedInsulator,
        price: val.value,
        noFormat,
      },
      insulators,
    }, () => {
      this.calculateThermalvalue();
      this.calculateInsulators();
    });
  }

  checkConformity() {
    const { thermalValue } = this.state;
    const { resValue } = this.props;
    const { onConformitychange, onIsEnoughChange } = this.props;

    const isEnough = resValue <= thermalValue;
    onConformitychange(true);
    onIsEnoughChange(isEnough);
  }

  calculateInsulators() {
    const { selectedInsulator } = this.state;
    const { isoValue } = this.props;

    const costs = RtMaxService.calculateCost(
      [{
        type: ProductType.INSULATOR,
        productData: selectedInsulator,
      }],
      isoValue,
      envList.IME.path
    );

    this.setState({
      insulatorRoll: costs.insulator.nbRoll,
      usedInsulator: costs.insulator.usedInsulator,
      insulatorCost: costs.insulator.insulatorCost,
    }, () => {
      this.calculTotal();
    });
  }

  calculateSupport() {
    const { selectedSupport } = this.state;
    const { isoValue } = this.props;

    const costs = RtMaxService.calculateCost(
      [{
        type: ProductType.SUPPORT,
        productData: selectedSupport,
      }],
      isoValue,
      envList.IME.path
    );

    const { support } = costs;

    this.setState({
      supportBox: support.nbBox,
      usedSupport: support.usedSupport,
      supportCost: support.supportCost,
    }, () => {
      this.calculTotal();
    });
  }

  calculTotal() {
    const {
      supportCost,
      insulatorCost,
      membraneCost,
      pastilleCost,
      adhesifCost,
      masticCost,
    } = this.state;
    const { onTotalChange, worktype } = this.props;

    onTotalChange(
      (supportCost || 0)
      + (insulatorCost || 0)
      + ((worktype === '2' && membraneCost) || 0)
      + (pastilleCost || 0)
      + (adhesifCost || 0)
      + (masticCost || 0)
    );

    this.checkConformity();
  }

  calculateThermalvalue() {
    const { onThermalChange } = this.props;
    const { selectedInsulator } = this.state;

    const thermalValue = (Number(selectedInsulator && selectedInsulator.resistance)).toFixed(1);
    this.setState({ thermalValue }, this.checkConformity);
    onThermalChange(thermalValue);
  }

  calculateMembrane() {
    const { selectedMembrane } = this.state;
    const { isoValue } = this.props;

    const {
      membrane: {
        membranebox,
        usedMembrane,
        membraneCost,
      },
    } = RtMaxService.calculateCost(
      [{
        type: ProductType.MEMBRANE,
        productData: selectedMembrane,
      }],
      isoValue,
      envList.IME.path
    );

    this.setState({
      membranebox,
      usedMembrane,
      membraneCost,
    }, () => {
      this.calculTotal();
    });
  }

  calculatePastille() {
    const { selectedPastille } = this.state;
    const { isoValue } = this.props;

    const {
      pastille: {
        pastilleBox,
        usedPastille,
        pastilleCost,
      },
    } = RtMaxService.calculateCost(
      [{
        type: ProductType.PASTILLE,
        productData: selectedPastille,
      }],
      isoValue,
      envList.IME.path
    );

    this.setState({
      pastilleBox,
      usedPastille,
      pastilleCost,
    }, () => {
      this.calculTotal();
    });
  }

  calculateAdhesif() {
    const { selectedAdhesif } = this.state;
    const { isoValue } = this.props;

    const {
      adhesive: {
        adhesifBox,
        usedAdhesif,
        adhesifCost,
      },
    } = RtMaxService.calculateCost(
      [{
        type: ProductType.ADHESIVE,
        productData: selectedAdhesif,
      }],
      isoValue,
      envList.IME.path
    );

    this.setState({
      adhesifBox,
      usedAdhesif,
      adhesifCost,
    }, () => {
      this.calculTotal();
    });
  }

  calculateMastic() {
    const { selectedMastic } = this.state;
    const { isoValue } = this.props;

    const {
      mastic: {
        masticBox,
        usedMastic,
        masticCost,
      },
    } = RtMaxService.calculateCost(
      [{
        type: ProductType.MASTIC,
        productData: selectedMastic,
      }],
      isoValue,
      envList.IME.path
    );

    this.setState({
      masticBox,
      usedMastic,
      masticCost,
    }, () => {
      this.calculTotal();
    });
  }

  render() {
    const { t, worktype } = this.props;

    const {
      adhesifBox,
      adhesifCost,
      adhesifs,
      insulatorCost,
      insulatorRoll,
      insulators,
      masticBox,
      masticCost,
      mastics,
      membranebox,
      membraneCost,
      membranes,
      pastilleBox,
      pastilleCost,
      pastilles,
      selectedAdhesif,
      selectedInsulator,
      selectedMastic,
      selectedMembrane,
      selectedPastille,
      selectedSupport,
      supportBox,
      supportCost,
      supports,
      usedAdhesif,
      usedInsulator,
      usedMastic,
      usedMembrane,
      usedPastille,
      usedSupport,
      size,
    } = this.state;

    const token = sessionStorage.getItem('USER_TOKEN');

    return (
      <Table basic="very" className={worktype === '2' ? 'tableRtMaxSoluce' : 'tableRtPlusSoluce'}>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell />
            <Table.HeaderCell>
              {t('rtmax_table_title')}
            </Table.HeaderCell>
            <Table.HeaderCell />
            <Table.HeaderCell>
              {t('rtmax_table_title_quantity')}
            </Table.HeaderCell>
            <Table.HeaderCell>
              {t('rtmax_table_title_unité')}
            </Table.HeaderCell>
            <Table.HeaderCell>
              {t('rtmax_table_title_surface')}
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          <Table.Row>
            <Table.Cell>
                1.
            </Table.Cell>
            <Table.Cell className={worktype === '2' ? 'cellTablertMax' : 'cellTablertPlus'}>
              {t('rtmax_table_insulation')}
              <TechnicalInfoIcon
                t={t}
                onClick={this.onClickTechnicalInfo}
              />
              <br />
              <Dropdown
                search
                selection
                disabled
                options={insulators}
                value={selectedInsulator}
                onChange={(e, val) => this.changeSousChevrons(e, val)}
              />
            </Table.Cell>
            <Table.Cell className="cellTable">
              {usedInsulator || 0}
              {' '}
              {t('rtmax_table_insulation_surfaces')}
            </Table.Cell>
            <Table.Cell className="cellTableQuantity">
              {`${insulatorRoll || 0} `}
              {' '}
              {t('rtmax_table_insulation_content_type')}
            </Table.Cell>
            <Table.Cell className={worktype === '2' ? 'cellTablertMax' : 'cellTablertPlus'}>
              <Form className="inputInTable">
                <Form.Input
                  type="number"
                  onClick={e => e.target.select()}
                  width={8}
                  step={0.10}
                  disabled={token === null || UserService.isUser()}
                  value={
                    selectedInsulator && selectedInsulator.noFormat
                      ? selectedInsulator && selectedInsulator.price
                      : Number(selectedInsulator && selectedInsulator.price).toFixed(2)
                  }
                  onChange={(e, val) => this.changeInsulator(e, val, true)}
                  onBlur={
                    () => this.changeInsulator(
                      null,
                      { value: selectedInsulator && selectedInsulator.price },
                      false
                    )
                  }
                />
                <Label className={size <= 992 ? 'labelInFormTablette' : 'labelInForm'}>
                  {t('rtmax_table_insulation_unit_price')}
                </Label>
              </Form>
            </Table.Cell>
            <Table.Cell className="cellTable">
              {(insulatorCost || 0).toFixed(2)}
              {' '}
              {t('rtmax_table_insulation_price')}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>
                2.
            </Table.Cell>
            <Table.Cell className={worktype === '2' ? 'cellTablertMax' : 'cellTablertPlus'}>
              {t('rtmax_table_support')}
              <TechnicalInfoIcon
                t={t}
                onClick={() => {
                  if (selectedSupport) ComponentTableIME.clickDownloadPdf(selectedSupport.link);
                }}
              />
              <br />
              <Dropdown
                search
                selection
                disabled
                options={supports}
                default={selectedSupport}
                value={selectedSupport}
              />
            </Table.Cell>
            <Table.Cell className="cellTable">
              {(usedSupport || 0).toFixed(2)}
              {' '}
              {t('rtmax_table_support_surfaces')}
            </Table.Cell>
            <Table.Cell className="cellTableQuantity">
              {(supportBox || 0).toFixed(2)}
              {' '}
              {t('rtmax_table_support_content_type')}
            </Table.Cell>
            <Table.Cell className={worktype === '2' ? 'cellTablertMax' : 'cellTablertPlus'}>
              <Form className="inputInTable">
                <Form.Input
                  type="number"
                  onClick={e => e.target.select()}
                  width={8}
                  step={0.10}
                  disabled={token === null || UserService.isUser()}
                  value={
                    selectedSupport && selectedSupport.noFormat
                      ? selectedSupport && selectedSupport.price
                      : Number(selectedSupport && selectedSupport.price).toFixed(2)
                  }
                  onChange={(e, val) => this.changeSupport(e, val, true)}
                  onBlur={
                    () => {
                      this.changeSupport(
                        null,
                        { value: selectedSupport && selectedSupport.price },
                        false
                      );
                    }
                  }
                />
                <Label className={size <= 992 ? 'labelInFormTablette' : 'labelInForm'}>
                  {t('rtmax_table_support_unit_price')}
                </Label>
              </Form>
            </Table.Cell>
            <Table.Cell className="cellTable">
              {(supportCost || 0).toFixed(2)}
              {' '}
              {t('rtmax_table_support_price')}
            </Table.Cell>
          </Table.Row>
          { worktype === '2' && (
            <Table.Row>
              <Table.Cell>
                3.
              </Table.Cell>
              <Table.Cell className={worktype === '2' ? 'cellTablertMax' : 'cellTablertPlus'}>
                {t('rtmax_table_membrane_IME')}
                <TechnicalInfoIcon
                  t={t}
                  onClick={() => {
                    if (selectedMembrane) ComponentTableIME.clickDownloadPdf(selectedMembrane.link);
                  }}
                />
                <br />
                <Dropdown
                  search
                  selection
                  options={membranes}
                  value={selectedMembrane}
                  onChange={this.changeMembrane}
                />
              </Table.Cell>
              <Table.Cell className="cellTable">
                {(usedMembrane || 0).toFixed(2)}
                {' '}
                {t('rtmax_table_membrane_IME_surfaces')}
              </Table.Cell>
              <Table.Cell className="cellTableQuantity">
                {(membranebox || 0).toFixed(2)}
                {' '}
                {t('rtmax_table_membrane_IME_content_type')}
              </Table.Cell>
              <Table.Cell className={worktype === '2' ? 'cellTablertMax' : 'cellTablertPlus'}>
                <Form className="inputInTable">
                  <Form.Input
                    type="number"
                    onClick={(e) => { e.target.select(); }}
                    width={8}
                    step={0.10}
                    disabled={token === null || UserService.isUser()}
                    value={
                      selectedMembrane && selectedMembrane.noFormat
                        ? selectedMembrane && selectedMembrane.price
                        : Number(selectedMembrane && selectedMembrane.price).toFixed(2)
                    }
                    onChange={(e, val) => this.changeMembranePrice(e, val, true)}
                    onBlur={
                      () => this.changeMembranePrice(
                        null,
                        { value: selectedMembrane && selectedMembrane.price },
                        false
                      )
                    }
                  />
                  <Label className={size <= 992 ? 'labelInFormTablette' : 'labelInForm'}>
                    {t('rtmax_table_membrane_IME_unit_price')}
                  </Label>
                </Form>
              </Table.Cell>
              <Table.Cell className="cellTable">
                {(membraneCost || 0).toFixed(2)}
                {' '}
                {t('rtmax_table_membrane_IME_price')}
              </Table.Cell>
            </Table.Row>
          )}
          <Table.Row>
            <Table.Cell>
              {worktype === '2' ? '4.' : '3.'}
            </Table.Cell>
            <Table.Cell className={worktype === '2' ? 'cellTablertMax' : 'cellTablertPlus'}>
              {t('rtmax_table_pastille')}
              <TechnicalInfoIcon
                t={t}
                onClick={() => {
                  if (selectedPastille) ComponentTableIME.clickDownloadPdf(selectedPastille.link);
                }}
              />
              <br />
              <Dropdown
                search
                selection
                disabled
                options={pastilles}
                value={selectedPastille}
                onChange={(e, val) => this.changeSousChevrons(e, val)}
              />
            </Table.Cell>
            <Table.Cell className="cellTable">
              {(usedPastille || 0).toFixed(2)}
              {' '}
              {t('rtmax_table_pastille_surfaces')}
            </Table.Cell>
            <Table.Cell className="cellTableQuantity">
              {(pastilleBox || 0).toFixed(2)}
              {' '}
              {t('rtmax_table_pastille_content_type')}
            </Table.Cell>
            <Table.Cell className={worktype === '2' ? 'cellTablertMax' : 'cellTablertPlus'}>
              <Form className="inputInTable">
                <Form.Input
                  type="number"
                  onClick={e => e.target.select()}
                  width={8}
                  step={0.10}
                  disabled={token === null || UserService.isUser()}
                  value={
                    selectedPastille && selectedPastille.noFormat
                      ? selectedPastille && selectedPastille.price
                      : Number(selectedPastille && selectedPastille.price).toFixed(2)
                  }
                  onChange={(e, val) => this.changePastillePrice(e, val, true)}
                  onBlur={
                    () => this.changePastillePrice(
                      null,
                      { value: selectedPastille.price },
                      false
                    )
                  }
                />
                <Label className={size <= 992 ? 'labelInFormTablette' : 'labelInForm'}>
                  {t('rtmax_table_pastille_unit_price')}
                </Label>
              </Form>
            </Table.Cell>
            <Table.Cell className="cellTable">
              {(pastilleCost || 0).toFixed(2)}
              {' '}
              {t('rtmax_table_pastille_price')}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>
              {worktype === '2' ? '5.' : '4.'}
            </Table.Cell>
            <Table.Cell className={worktype === '2' ? 'cellTablertMax' : 'cellTablertPlus'}>
              {worktype === '2' ? t('rtmax_table_adhesif_IME') : t('rtplus_table_adhesif_IME')}
              <TechnicalInfoIcon
                t={t}
                onClick={() => {
                  if (selectedAdhesif) ComponentTableIME.clickDownloadPdf(selectedAdhesif.link);
                }}
              />
              <br />
              <Dropdown
                search
                selection
                disabled
                options={adhesifs}
                value={selectedAdhesif}
                onChange={(e, val) => this.changeSousChevrons(e, val)}
              />
            </Table.Cell>
            <Table.Cell className="cellTable">
              {(usedAdhesif || 0).toFixed(2)}
              {' '}
              {t('rtmax_table_adhesif_IME_surfaces')}
            </Table.Cell>
            <Table.Cell className="cellTableQuantity">
              {(adhesifBox || 0).toFixed(2)}
              {' '}
              {t('rtmax_table_adhesif_IME_content_type')}
            </Table.Cell>
            <Table.Cell className={worktype === '2' ? 'cellTablertMax' : 'cellTablertPlus'}>
              <Form className="inputInTable">
                <Form.Input
                  type="number"
                  onClick={e => e.target.select()}
                  width={8}
                  step={0.10}
                  disabled={token === null || UserService.isUser()}
                  value={
                    selectedAdhesif && selectedAdhesif.noFormat
                      ? selectedAdhesif && selectedAdhesif.price
                      : Number(selectedAdhesif && selectedAdhesif.price).toFixed(2)
                  }
                  onChange={(_, val) => this.changeAdhesifPrice(_, val, true)}
                  onBlur={() => {
                    this.changeAdhesifPrice(null, { value: selectedAdhesif.price }, false);
                  }}
                />
                <Label className={size <= 992 ? 'labelInFormTablette' : 'labelInForm'}>
                  {t('rtmax_table_adhesif_IME_unit_price')}
                </Label>
              </Form>
            </Table.Cell>
            <Table.Cell className="cellTable">
              {(adhesifCost || 0).toFixed(2)}
              {' '}
              {t('rtmax_table_adhesif_IME_price')}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>
              {worktype === '2' ? '6.' : '5.'}
            </Table.Cell>
            <Table.Cell className={worktype === '2' ? 'cellTablertMax' : 'cellTablertPlus'}>
              {t('rtmax_table_mastic_IME')}
              <TechnicalInfoIcon
                t={t}
                onClick={() => {
                  if (selectedMastic) ComponentTableIME.clickDownloadPdf(selectedMastic.link);
                }}
              />
              <br />
              <Dropdown
                search
                selection
                disabled
                options={mastics}
                value={selectedMastic}
                onChange={(e, val) => this.changeSousChevrons(e, val)}
              />
            </Table.Cell>
            <Table.Cell className="cellTable">
              {(usedMastic || 0).toFixed(2)}
              {' '}
              {t('rtmax_table_mastic_IME_surfaces')}
            </Table.Cell>
            <Table.Cell className="cellTableQuantity">
              {(masticBox || 0).toFixed(2)}
              {' '}
              {t('rtmax_table_mastic_IME_content_type')}
            </Table.Cell>
            <Table.Cell className={worktype === '2' ? 'cellTablertMax' : 'cellTablertPlus'}>
              <Form className="inputInTable">
                <Form.Input
                  type="number"
                  onClick={e => e.target.select()}
                  width={8}
                  step={0.10}
                  disabled={token === null || UserService.isUser()}
                  value={
                    selectedMastic && selectedMastic.noFormat
                      ? selectedMastic && selectedMastic.price
                      : Number(selectedMastic && selectedMastic.price).toFixed(2)
                  }
                  onChange={(e, val) => { this.changeMasticPrice(e, val, true); }}
                  onBlur={
                    () => {
                      this.changeMasticPrice(
                        null,
                        { value: selectedMastic.price },
                        false
                      );
                    }
                  }
                />
                <Label className={size <= 992 ? 'labelInFormTablette' : 'labelInForm'}>
                  {t('rtmax_table_mastic_IME_unit_price')}
                </Label>
              </Form>
            </Table.Cell>
            <Table.Cell className="cellTable">
              {(Number(masticCost) || 0).toFixed(2)}
              {' '}
              {t('rtmax_table_mastic_IME_price')}
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }
}

export default translate('rtMaxSoluceComponent')(ComponentTableIME);



// WEBPACK FOOTER //
// ./src/components/shared/ComponentTableIME.jsx